module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "50vw",
      "min-width": "50vw"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', {
    staticClass: "uppercase center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Vanliga frågor")]), _vm._v(" "), _vm._l((_vm.faqs), function(ref, index) {
    var question = ref.question;
    var answer = ref.answer;

    return _c('div', {
      key: question,
      staticClass: "items-list"
    }, [_c('Collapsable', {
      attrs: {
        "title": question,
        "content": answer
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d109eab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolFaq.vue
// module id = 982
// module chunks = 0